__turbopack_context__.v({
  "className": "radiumwordmarkfont_5e18f83b-module__vM5bWG__className",
  "variable": "radiumwordmarkfont_5e18f83b-module__vM5bWG__variable",
});
